<div class="d-flex flex-row slider">
  <div class=" d-flex flex-row full-height"
    *ngFor="let item of slider, let last = last;"
    [ngClass]="{'flex-g1' : last !== true}">
    <div class="d-flex align-items-center">
      <div class="d-flex center-point"
           [ngClass]="{'read-only-status': readonly}"
        placement="bottom" ngbTooltip="{{item.name}}"
        (click)="!item.selected && change(item)">
        <div *ngIf="item.i > currentStatus.i || (item.i === 0 && currentStatus.i !== 0)"
          class="inner-point">
        </div>
        <img *ngIf="item.i <= currentStatus.i && item.i !== 0"
          class="inner-checkmark"
          src="/assets/images/Check_Green.svg">
        <img *ngIf="item.i === 0 && currentStatus.i === 0"
          class="inner-checkmark red-cross"
          src="/assets/images/Delete_Dark.svg">
      </div>
    </div>
    <div class="d-flex align-items-center full-width path-container">
      <div class="d-flex align-items-center path">
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-campaign-activity/campaign-influencer-status-slider/campaign-influencer-status-slider.component.html